// Shared by the anonymous nav bar and the blocked-action toast.
const SUBJECT = "Requesting access to swivl";
const BODY = `Hi there,

I'd like to get set up with a swivl login. Are you able to add me?

Invitation instructions can be found here: https://learn.tryswivl.com/inviting-members-to-swivlstudio if you need a refresher. Thanks so much!

Best,`;

// No default recipient — the visitor fills in who it goes to themselves.
export function buildRequestAccessMailtoHref(): string {
  return `mailto:?subject=${encodeURIComponent(SUBJECT)}&body=${encodeURIComponent(BODY)}`;
}
